import { useFeatures } from './useFeatures';
import { useInternalUser } from './use-internal-user';

/**
 * Whether the Codex engine (OpenAI `codex/*` models) should be surfaced to the current user:
 * the `codexEngine` feature flag is on OR the user is an OptiSigns internal user. Mirrors
 * `useByocEnabled`; every Codex render site (model dropdown, settings default model, mobile
 * settings) gates on this hook rather than on `features.codexEngine` directly. The gateway
 * enforces the same rule server-side (plus email verification).
 *
 * While loading we return `enabled: false` so a persisted `codex/…` selection never flashes on
 * a flag-off environment.
 */
export function useCodexEnabled(): { enabled: boolean; loading: boolean } {
  const { features, loading: featuresLoading } = useFeatures();
  const { isInternalUser, loading: internalLoading } = useInternalUser();
  const loading = featuresLoading || internalLoading;
  return {
    enabled: !loading && (features.codexEngine || isInternalUser),
    loading,
  };
}
